module.exports = __webpack_public_path__ + "94d5cee3a82fb424a4db058c08c0dcff.pdf";